import { render, staticRenderFns } from "./ResourcesLesson.vue?vue&type=template&id=82bce580&"
import script from "./ResourcesLesson.vue?vue&type=script&lang=js&"
export * from "./ResourcesLesson.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports